import CrudRepository from './CrudRepository'
export default class JobsRepository extends CrudRepository {
  constructor () {
    super('core/api/jobs/all')
  }
}
